import { jsx as r } from "react/jsx-runtime";
import { R as a } from "../../../vendor--aJiswR_.js";
import '../../../assets/index38.css';const o = "_header_1i82p_1", s = {
  header: o
};
function d({ children: e }) {
  return /* @__PURE__ */ r(a, { className: s.header, children: e });
}
export {
  d as Header
};
//# sourceMappingURL=index.js.map
